<template>
    <div class="bg-light">
        <Heading class="mb-md-5 text-center" :title="$t('login_auth')" :routeName="'vignette'"></Heading>
        <div class="container container-small bg-md-white">
            <p class="heading heading-small">{{ $t('login_login_into_your_account') }}</p>
            <div class="bg-white">
                <LoginComponent></LoginComponent>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import LoginComponent from './LoginComponent.vue'

export default {
     name: 'Login',
     components: {
          LoginComponent,
          Heading
     },
     props: {
     },
     data: function() {
          return {
          }
     },
     mounted: function() {
     },
     methods: {
     }
}
</script>

<style lang="scss" scoped>

     $lightgrey: lightgrey;
     $green: #59af54;

     .heading {

         margin: 0px;

         @media only screen and (max-width: 768px) {
             margin-bottom: 30px;
         }
     }

     .bg-md-white {
         @media only screen and (min-width: 769px) {
             background: white;
             padding: 28px 50px;
         }
     }

     .bg-white {

         @media only screen and (max-width: 768px) {
             margin: 0px -18px;
             padding: 39px 18px;
         }
     }

     .bg-light {

        @media only screen and (min-width: 769px) {
            padding-top: 126px;
            padding-bottom: 114px;
        }

        @media only screen and (max-width: 768px) {
            padding-top: 46px;
            padding-bottom: 61px;
        }
     }

     .container{
         @media only screen and (max-width: 768px) {
             margin-top: 6px;
         }

          p {
              font-weight: bold;
              text-align: center;

              @media only screen and (min-width: 768px) {
                  font-size: 22px;
              }
          }
          .border-right{
               border-right: 1px solid #C7C7C6;
          }
     }

     .lower-bottom-margin {
          font-size: 22px;
          font-weight: bold;
     }

     .google-button {
          button {
               width: 100%;
               padding: 5px 0px;
               margin-top: 7px;
               margin-bottom: 7px;
               background-color: #e94334;
               border-color: #e94334;
               font-size: 14px;
          }
     }

     .facebook-button {
          button {
               width: 100%;
               padding: 5px 0px;
               margin-top: 7px;
               margin-bottom: 7px;
               background-color: #428bc9;
               border-color: #428bc9;
               font-size: 14px;
          }
     }
</style>
